// 个人中心顶部展示的用户级别的通知类型, 暂时只有未设置密码
export type MessageType = 'password';

export interface AlertItemProps {
    content: string; // 前面的文案内容
    btnText: string; // 点击需要跳转的文案内容
    restContent?: string; // 后面部分的文案内容
    type: MessageType;
    href: string;
    // 是否是内部链接
    internal?: boolean;
}

export const notifyConfig: Record<MessageType, Omit<AlertItemProps, 'href'>> = {
    password: {
        content: __('您的账户暂未设置登录密码，'),
        btnText: __('请尽快设置登录密码'),
        type: 'password',
        internal: true
    }
};
